import i18next from 'i18next';
import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { usePlans } from '../../api/hooks/usePlans';
import { SUBSCRIPTION } from '../../interfaces/enumerables';
import { PATHS } from '../../navigation/data';
import { selectSelectedCompany } from '../../store/companies/companiesSlice';
import { setToast } from '../../store/core/coreSlice';
import { store } from '../../store/store';
import { isPlanCovered } from './planUtils';

export const useHasActivePlan = (redirectHome = false, planId?: SUBSCRIPTION) => {
  const company = useSelector(selectSelectedCompany);
  const { data, isLoading, isSuccess, isError } = usePlans(company?.vatNumber || '');
  const navigate = useNavigate();

  const redirectHomeAction = useCallback(
    (msg: string) => {
      navigate(PATHS.HOME, { replace: true });
      store.dispatch(
        setToast({
          value: {
            show: true,
            msg: i18next.t(msg),
            isError: true,
            duration: 30000,
          },
        }),
      );
    },
    [navigate],
  );

  useEffect(() => {
    if (isSuccess && redirectHome) {
      if (planId && !isPlanCovered(data?.activePlans, planId)) {
        redirectHomeAction('PLANS.NO_ACTIVE_PLAN_FOR_FEATURE');
        return;
      }

      if (!data?.hasPlansActive) {
        redirectHomeAction('PLANS.NO_ACTIVE_PLANS_DISABLED_FEATURES');
        return;
      }
    }
  }, [isSuccess, redirectHome, data, planId, redirectHomeAction]);

  // Something is off with the server => let user use the app
  if (isError) return true;

  if (planId) return isLoading || isPlanCovered(data?.activePlans, planId);

  return isLoading || data?.hasPlansActive;
};
